<div id="hods" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Academic Leadership (HOD's)</h2>
    <p class="inner-lead mt-3">
      The Heads of Departments (HODs) at Shah Satnam Ji Girls' College provide strong academic leadership. They are
      responsible for the academic, administrative and developmental activities within their respective departments.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">HODs Document</h4>

    <!-- NOTE: Upload the HODs image/document to: src/assets/pdf/admin/hods.jpg -->
    <div class="pdf-block text-center">
      <img src="/assets/img/admin/1.jpeg" alt="Academic Leadership — HODs" class="img-fluid img-rounded-shadow"
        onerror="this.style.display='none'">
    </div>

    <div class="mt-3">
      <a href="/assets/img/admin/1.jpeg" target="_blank" class="download-btn">
        <i class="fa fa-external-link"></i> View Full Image
      </a>
    </div>

  </div>
</div>